import { WebpMachine } from "webp-hero";
import $ from "jquery";
import Swup from 'swup';
import SwupPreloadPlugin from '@swup/preload-plugin'; //preload
import SwupGtmPlugin from '@swup/gtm-plugin'; //GTM integration
import SwupScrollPlugin from '@swup/scroll-plugin'; //scrolling support 
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import Chart from 'chart.js/auto';
import Croppie from "croppie";

window.jQuery = $;

import { config } from "../data/global.yaml";
var process; // need to define to access global provided by Webpack

// Splash Screen
$(document).ready(function() {
  setTimeout(function() {
      $(".grid-bg").removeClass("grid-bg");
      $(".intro").removeClass("intro");
    }, 3000);
});

// On DOM ready
$(async () => {

    //Initiate Swup
    const swup = new Swup({
        plugins: [
            new SwupPreloadPlugin(),
            new SwupGtmPlugin(),
            new SwupBodyClassPlugin(),
            new SwupScrollPlugin({
              animateScroll: false,
            }),
        ]
    });
    
    swup.on('pageView', () => {
        $(document).trigger('lfbb:load');
    });

    // run once when page loads
    initialize();

    // run after every additional navigation by swup
    swup.on('contentReplaced', initialize);
    
    // Detect WebP support and polyfill to PNG if unsupported
    const webpMachine = new WebpMachine({
        webpSupport: undefined,  //set false to force update
        useCanvasElements: false,
    });
    webpMachine.polyfillDocument();

    //routing
    function initialize(){
        menuInit();

        /* ######## PAGE: HOME  ######## */
        if ($('.page-home').length) {
            const elementHeight = $('.page-home #meet').outerHeight();
            $('#dynamic-spacer').height(elementHeight);

            $(window).off('resize');
            $(window).on('resize', function() {
              if ($('.page-home').length) {
                const elementHeight = $('.page-home #meet').outerHeight();
                $('#dynamic-spacer').height(elementHeight);
              }
            });
        }

        /* ######## PAGE:BrandDNA ######## */
        if ($('.page-branddna').length) {
          const accordionToggles = document.querySelectorAll('.accordion-toggle');
        
          function toggleAccordion() {
            this.classList.toggle('active');
          }
        
          accordionToggles.forEach(function(toggle) {
            toggle.removeEventListener('click', toggleAccordion);
            toggle.addEventListener('click', toggleAccordion);
          });
        }
      
        /* ######## PAGE: COLORS ######## */
        if($('.page-color').length) {
            const speed = 400;
            const toast = $('<div class="toast-colors">Copied</div>');

            $(".swatch .ico-copy, .swatch .hex").off('click');
            $(".swatch .ico-copy, .swatch .hex").on('click', function() {
                let color = $(this).parent().data('color');
                navigator.clipboard.writeText(color);
                $(this).parent().append(toast);

                setTimeout(function() {
                    toast.css({
                    'opacity': '1',
                    'transform': 'translateY(0)'
                    });
                }, 100);
    
                setTimeout(function() {
                    toast.css({
                    'opacity': '0',
                    'transform': 'translateY(-50px)'
                    });
                }, 2000);
    
                setTimeout(function() {
                    toast.remove();
                }, 2300);
            });

            $(".swatch").off('click');
            $(".swatch").on('click', function(e) {
               if(!$(this).hasClass('expanded')) {
                if(!$(e.target).closest('i, span').length > 0) {
                    $("#" + $(this).attr('id') + " .ico-expand").click();
                }
               }
            });
        
            
            $(".swatch .ico-expand").off('click');
            $(".swatch .ico-expand").on('click', function(e) {
                let swatch_type = $(this).parent().parent();
                let swatch_type_class = "." + $(swatch_type)[0].classList[0];
                if($(this).parent().siblings('.expanded').length){
                    $(swatch_type_class + " .expanded .ico-close").click();
                }
                if(!$(swatch_type).hasClass('opened')) {
                    $(swatch_type).addClass('opened');
                }
                $(this).parent().addClass('expanded');
                $(this).fadeOut(speed).promise().done(function(){   
                    $(this).parent().children(".group-1").fadeIn(speed);
                });
            });
        
            
            $(".swatch .ico-close").off('click');
            $(".swatch .ico-close").on('click', function(e) {
                let swatch_type = $(this).parent().parent();
                let swatch_type_class = "." + $(swatch_type)[0].classList[0];
                $(swatch_type).removeClass('opened');
                $(this).parent().removeClass('expanded');
                $(this).parent().children(".group-1").fadeOut(speed).promise().done(function(){   
                    $(this).siblings('.ico-expand').fadeIn(speed);
                });
            });

          	if(!$("#hierarchy").hasClass('loaded')) {
              $("#hierarchy").addClass('loaded');

              var dataset1 = {
                labels: [
                  'Blue',
                  'White',
                  'Black'
                ],
                datasets: [{
                  label: '',
                  data: [270, 40, 50],
                  borderColor: '#EDEFF2',
                  backgroundColor: [
                    'rgb(4, 30, 64)',
                    'rgb(18, 18, 18)',
                    'rgb(255, 255, 255)',
                  ],
                  hexColor: [
                    '#041E40',
                    '#121212',
                    '#FFFFFF',
                  ],
                  hoverOffset: 4
                }]
              };
        
              var dataset2 = {
                labels: [
                  'Orange',
                  'Black',
                  'White',
                  'Blue',
                ],
                datasets: [{
                  label: '',
                  data: [90, 40, 50, 180],
                  borderColor: '#EDEFF2',
                  backgroundColor: [
                    'rgb(241, 95, 65)',
                    'rgb(18, 18, 18)',
                    'rgb(255, 255, 255)',
                    'rgb(4, 30, 64)',
                  ],
                  hexColor: [
                    '#F15F41',
                    '#121212',
                    '#FFFFFF',
                    '#041E40',
                  ],
                  hoverOffset: 4
                }]
              };
        
              // Brand Standard Chart.
              var ctx = document.getElementById('hierarchyChart').getContext('2d');
              var chart = new Chart(ctx, {
                type: 'pie',
                data: dataset2,
                options: {
                  responsive: true,
                  animation: {
                    duration: 500,
                  },
                  plugins: {
                    legend: {
                      display: false,
                    },
                    tooltip: {
                      callbacks: {
                        label: function(context) {
                          var label = context.label || '';
                          var dataset = context.dataset;
                          var value = dataset.data[context.dataIndex];
                          var color = dataset.hexColor[context.dataIndex];
                          return " " + color;
                        }
                      }
                    },
                  },                
                },
                plugins: [{
                  beforeInit: function(chart, args, options) {
                    if (chart.canvas.id === "hierarchyChart") {
                      const ul = document.createElement('ul');
                      chart.data.labels.forEach((label, i) => {
                        const li = document.createElement('li');
                        const span = document.createElement('span');
                        span.style.backgroundColor = chart.data.datasets[0].backgroundColor[i];
                        span.setAttribute('data-total', chart.data.datasets[0].data[i]);
                        li.appendChild(span);
                        li.appendChild(document.createTextNode(label));
                        li.addEventListener('click', function() {
                          chart.getDatasetMeta(0).data[i].hidden = !chart.getDatasetMeta(0).data[i].hidden;
                          chart.update();
                          this.classList.toggle('inactive');
                        });
                        ul.appendChild(li);
                      });
                      return document.getElementById("legend").appendChild(ul);
                    }
                    return;
                  },
                }],
              });

              // Luxury Chart.
              var ctxLuxury = document.getElementById('hierarchyChartLuxury').getContext('2d');
              var chartLuxury = new Chart(ctxLuxury, {
                type: 'pie',
                data: dataset1,
                options: {
                  responsive: true,
                  animation: {
                    duration: 500,
                  },
                  rotation: 180,
                  plugins: {
                    legend: {
                      display: false,
                    },
                    tooltip: {
                      callbacks: {
                        label: function(context) {
                          var label = context.label || '';
                          var dataset = context.dataset;
                          var value = dataset.data[context.dataIndex];
                          var color = dataset.hexColor[context.dataIndex];
                          return " " + color;
                        }
                      }
                    },
                  },                
                },
                plugins: [{
                  beforeInit: function(chart, args, options) {
                    if (chart.canvas.id === "hierarchyChartLuxury") {
                      const ul = document.createElement('ul');
                      chart.data.labels.forEach((label, i) => {
                        const li = document.createElement('li');
                        const span = document.createElement('span');
                        span.style.backgroundColor = chart.data.datasets[0].backgroundColor[i];
                        span.setAttribute('data-total', chart.data.datasets[0].data[i]);
                        li.appendChild(span);
                        li.appendChild(document.createTextNode(label));
                        li.addEventListener('click', function() {
                          chart.getDatasetMeta(0).data[i].hidden = !chart.getDatasetMeta(0).data[i].hidden;
                          chart.update();
                          this.classList.toggle('inactive');
                        });
                        ul.appendChild(li);
                      });
                      return document.getElementById("legendLuxury").appendChild(ul);
                    }
                    return;
                  },
                }],
              });
              return false;
            }

        }

        /* ######## TOGGLE LIGHT/DARK MODE ######## */
        if($('.page-type,.page-logos').length) {
          $(".toggle-switch#dark-mode").off('click');
          $('.toggle-switch#dark-mode').on('click', function() {
            $(this).toggleClass('active');
            $('section.switch-mode').toggleClass('active');
          });          
        }


        /* ######## PAGE: ICONOGRAPHY ######## */

  
        /* ######## PAGE: SIGNAGE ######## */

        if($('.page-signage').length) {

          $("#signRange").off('click');
          $("#signRange").on('input', function() {
              var val = $(this).val();
              var signageDemo = $('#signageDemo');

              // label
              let label = document.getElementById('amtLabel');

              // do the math to reformat value to curr
              label.style.left = ((val - 50000) / 2450000) * 100 + '%';
              if (val >= 1000000) {
                label.textContent = (val / 1000000).toFixed(1).replace(".0", "") + 'm';
              } else {
                label.textContent = Math.floor(val / 1000) + 'k';
              }

              // swinging sign animation
              signageDemo.removeClass('panel lux1 lux2');
              $('.sign').removeClass('swing');
              if(val < 1000000) {
                signageDemo.addClass('panel');
                $('.sign').addClass('swing');
              } else if(val <= 1400000) {
                signageDemo.addClass('lux1');
                $('.sign').addClass('swing');
              } else {
                signageDemo.addClass('lux2');
                $('.sign').addClass('swing');
              }
              window.setTimeout(function() {
                $('.sign').removeClass('swing');
                }, 500);
          });

        }

        /* ######## PAGE: TYPOGRAPHY ######## */
        if($('.page-type').length) {
          
          $("#font-size-input").off('click');
          $('#font-size-input').on('input', function() {
            let fontSize = $(this).val();
            if (fontSize > 60) {
              fontSize = 60;
            } else if (fontSize < 16) {
              fontSize = 16;
            }
          });
          
          // Demo weight slider change event
          $('#demo-weight-slider, #demo-spacing-slider, #font-size-input').off('click');
          $('#demo-weight-slider, #demo-spacing-slider, #font-size-input').on('input', function() {
            var demoWeightCSS = "font-size:" + $('#font-size-input').val() + "px;";
            demoWeightCSS += "font-variation-settings: 'wdth' " + $('#demo-spacing-slider').val() + ", 'wght' " + $('#demo-weight-slider').val();
            $('#dynamic-font').attr('style', demoWeightCSS);
          });

        }


    }
});

/*** menu.js ***/
let toggle_pause = false;
let scrollTimeout = null;

window.onload = function() {
	menuInit();
	toc_states();
    currentPageMenu();
};

$(document).on('lfbb:load', async() => {
    $('nav .active, .mobilemenu .active').removeClass('active');
    currentPageMenu();
});

window.currentPageMenu = function() {
    const currentPage = window.location.pathname.split('/').pop();
	const parentAnchorLink = document.querySelector(`nav a[href="/${currentPage}"]`);
	
	if (parentAnchorLink) {
	  const parentListItem = parentAnchorLink.closest('li');
  
	  if (parentListItem) {
		parentListItem.classList.add('active');
	  }
	}
}

window.menuInit = function menuInit() {
	toc_states();

	$(".menu-close").off('click');
	$(".menu-close").on("click", function() {
		$(".primary-nav").addClass('collapsed');
	});

	$(".thin").off('click');
	$(".thin").on("click", function() {
		$(".primary-nav").removeClass('collapsed');
	});


	//reset menu
	$(".primary-nav .logo a").off('click');
	$(".primary-nav .logo a").on("click", function() {
		$('[data-toc]').removeClass('active');
		$('.menu-single').removeClass('active');
		$('.expand-items').parent().removeClass('active');
	});


	$("nav .full .scroll > ul li a").off('click');
	$("nav .full .scroll > ul li a").on("click", function(e) {
		// toggle_pause = true;
		$('[data-toc]').removeClass('active');
		$('.menu-single').removeClass('active');

		if ($(this).data('toc') == "brand-narrative") {
			// toggle_pause = true;
			$("section#narrative .accordion-toggle").removeClass('active');
			$("section#narrative .accordion-toggle").addClass('active');
		}

		if ($(this).data('toc') == "brand-vision") {
			// toggle_pause = true;
			$("section#vision .accordion-toggle").removeClass('active');
			$("section#vision .accordion-toggle").addClass('active');
		}

		// if ($(this).data('toc') == "brand-promise") {
		// 	// toggle_pause = true;
		// 	$("section#promise .accordion-toggle").removeClass('active');
		// 	$("section#promise .accordion-toggle").addClass('active');
		// }
		
		if($(this).attr('data-toc') !== undefined) {
			$(this).addClass('active');
		} else if($(this).hasClass('expand-items')) {
			$('.expand-items').parent().removeClass('active');
			$(this).parent().addClass('active');
		} else if($(this).hasClass('menu-single')) {
			$('.expand-items').parent().removeClass('active');
			$(this).addClass('active');
		}

		// toggle_pause = false;
		setScrollTimeout();
	});

	
	if(!$(".mobilemenu").length > 0) {
		var scrollDiv = $('.scroll');  
		var menuDiv = $('<div>').addClass('mobilemenu');
		var topLevelUl = $('<ul>');
		
		scrollDiv.find('> ul > li').each(function() {
		  var topLevelLi = $('<li>');
		  var topLevelText = $(this).find('> span').text();
		  var topLevelAnchor = $('<a>').attr('href', '#').text(topLevelText);
		  
		  topLevelLi.append(topLevelAnchor);
		  
		  var subMenuDiv = $('<div>').addClass('sub-menu');
		  var subMenuUl = $('<ul>');
		  
		  // iterate through each second-level li element
		  $(this).find('> ul > li').each(function() {
			var subMenuLi = $('<li>');
			var subMenuText = $(this).find('> a').text();
			var subMenuHref = $(this).find('> a').attr('href');
			var subMenuAnchor = $('<a>').attr('href', subMenuHref).text(subMenuText);
			
			subMenuLi.append(subMenuAnchor);      
			subMenuUl.append(subMenuLi);
		  });
		  
		  subMenuDiv.append(subMenuUl);   
		  topLevelLi.append(subMenuDiv);
		  topLevelUl.append(topLevelLi);
		});
		
		menuDiv.append(topLevelUl);
		$('#mobile-nav-outer').append(menuDiv);
	  
	  $(".submenu").hide();
	  
	  // Toggle the menu when the burger icon is clicked
	  $(".burger").off('click');
	  $(".burger").on("click", function() {
		$(".mobilemenu").toggleClass("active");
		$(".burger").toggleClass("active");
	  });
	  
	  // Toggle the submenu when a menu item is clicked
	  $(".mobilemenu > ul > li > a").off('click');
	  $(".mobilemenu > ul > li > a").on("click", function(e) {
		var parentElement = $(this).parent();
		var timeoutId = parentElement.data("timeoutId");

		e.preventDefault();

		if($(this).parent().hasClass("active")) {
			$(".mobilemenu > ul > li").removeClass("active");
		} else {
			if($(".mobilemenu > ul > li").hasClass("active")) {
				$(".mobilemenu > ul > li").removeClass("active");
				if (timeoutId) {
					clearTimeout(timeoutId);
				}

				timeoutId = setTimeout(function() {
					parentElement.addClass("active");
				}, 550);
				parentElement.data("timeoutId", timeoutId);
			} else {
				parentElement.addClass("active");
			}
		}
	  });


	  $(".mobilemenu > ul > li .sub-menu a").off('click');
	  $(".mobilemenu > ul > li .sub-menu a").on("click", function(e) {
		$(".mobilemenu, .burger").removeClass("active");
	  });

	}
	  
}

$(document).ready(function() {
	toc_states(); // Call toc_states() on page load
});

function toc_states() {
    const windowHeight = $(window).height();
    const scrollTop = $(window).scrollTop();
    const viewportTop = scrollTop + windowHeight / 2;
    let activeSection = null;

    $(window).off('scroll');
    $(window).on('scroll', function() {
        if(toggle_pause == true) {
        // toggle_pause = false;

        // clearTimeout(scrollTimeout);  
        // scrollTimeout = setTimeout(function() {
        // 	// Scrolling has finished
        // 	console.log('delay over');			
        // }, 200);
        } else {
            toc_states();
        }
    });

    $('[data-toc-section]').each(function() {
        const section = $(this);
        const sectionTop = section.offset().top;
        const sectionBottom = sectionTop + section.outerHeight();

        if (viewportTop >= sectionTop && viewportTop <= sectionBottom) {
            activeSection = section.attr('data-toc-section');
            return false; // Exit the loop if active section is found
        }
    });


    $('[data-toc]').removeClass('active'); // Remove active class from all toc items
    $(`[data-toc="${activeSection}"]`).addClass('active'); // Add active class to the corresponding toc item

    /* if (activeSection) {
    // 	$('[data-toc]').removeClass('active'); // Remove active class from all toc items
    //   	$(`[data-toc="${activeSection}"]`).addClass('active rrrr'); // Add active class to the corresponding toc item
    // //   console.log('active section	' + activeSection);
    // 	console.log('testyes');
    // } else {
    // 	console.log('testNO');
    } */
}

function setScrollTimeout() {
    if (scrollTimeout !== null) {
        clearTimeout(scrollTimeout); // Clear the existing timer
        scrollTimeout = null; // Reset the timer variable
    }

    clearTimeout(scrollTimeout);

    toggle_pause = true;

    scrollTimeout = setTimeout(function() {
        // Scrolling has finished
    //   console.log('delay over');
        toggle_pause = false; // Reset the flag
    }, 350);
}

/*** signature.js ***/
const siteUrl = process.env.SITE_URL || config.site.url;
const apiUrl = process.env.API_URL || config.api.url;
const portraitUrl = process.env.PORTRAIT_URL || config.portrait.url;
const emailFilter = process.env.EMAIL_FILTER || config.email.filter;

var $uploadCrop;
var el;
const allowedCharacters = /^[\p{Alpha}\p{M}\p{Zs}0-9\s'\-,.@]*$/u;
const allowedCharacters_phone = /^[0-9.]*$/;
const allowedCharacters_ophone = /^[0-9.]*$/;
const allowedCharacters_zip = /^[0-9]*$/;
const allowedCharacters_title = /^[\p{Alpha}\p{M}\p{Zs}0-9\s':\/,.\-@&#()]*$/u;
const allowedCharacters_url = /^[a-zA-Z0-9\s':\/.\-@#]*$/;
const allowedCharacters_addr = /^[\p{Alpha}\p{M}\p{Zs}0-9\s'\-,.@#]*$/u;

const signatureInit = async() => {
    // console.log('signature init');
    if ($('.page-signature').length) {
        if ($('#img-cropper').length) {
            const getFormData = (form) => {
                return $(form)
                .serializeArray()
                .reduce((obj, { name, value }) => {
                    obj[name] = value;
                    return obj;
                }, {});
            };
            const errorMessage = (form, message) => {
                $('<div class="error">' + message + '</div>')
                .appendTo(form)
                .slideDown('slow')
                .delay(1000)
                .slideUp('slow', () => { $('.error').remove(); });
            }
            $('#validation-form').off('submit');
            $('#validation-form').on('submit', function(e) {
                e.preventDefault();
                const data = getFormData('#validation-form');
    
                //validate email
                let allowed = new RegExp(emailFilter).test(data.email);
                if(!allowed) {
                    errorMessage('#validation-form', 'Email domain not allowed.');
                    return;
                }
                $('#validation-form button').text('Sending').prop("disabled", true);
                
                $.ajax({
                    url: `${apiUrl}/validate`,
                    crossDomain: true,
                    type: "POST",
                    contentType: "application/json",
                    dataType: 'json',
                    data: JSON.stringify(data),
                }).done(response => {
                    if(response.result == 'SUCCESS') {
                        $('.validate-email').addClass('hidden');
                        $('.verify-code').removeClass('hidden');
                        $('#verification-form input[name=email]').val(data.email);
                    } else {
                        console.log('validate API returned error');
                        $('#validation-form button').text('Validate').prop("disabled", false);
                        errorMessage('#validation-form', 'Email not sent.');
                    }
                }).fail((xhr, resp, text) => {
                    console.log(xhr, resp, text); //DEBUG
                    errorMessage('#validation-form', 'Server returned error.');
                }).always(() => {
    
                });
            });

            $('#validation-form input[name=email]').off('change keyup paste');
            $('#validation-form input[name=email]').on('change keyup paste', function(e) {
                const text = $(this).val();
                if( text != text.toLowerCase() ) {
                    $(this).val( text.toLowerCase() );
                }
            });
    
            $('#verification-form').off('submit');
            $('#verification-form').on('submit', function(e) {
                e.preventDefault();
    
                var isValid = validateCode(this);
    
                if (!isValid) {
                    return false;
                }
    
                $('#verification-form button').text('Sending').prop("disabled", true);
                
                const data = getFormData('#verification-form');
                $.ajax({
                    url: `${apiUrl}/verify`,
                    crossDomain: true,
                    type: "POST",
                    contentType: "application/json",
                    dataType: 'json',
                    data: JSON.stringify(data),
                }).done(response => {
                    if(response.result == 'SUCCESS') {
                        $('.verify-code').addClass('hidden');
                        $('.upload-img').removeClass('hidden');
                        //TODO set cookie maybe
                    } else {
                        console.log('validate API returned error');
                        $('#verification-form button').text('Verify').prop("disabled", false);
                        errorMessage('#verification-form', 'Code is invalid.');
                    }
                }).fail((xhr, resp, text) => {
                    console.log(xhr, resp, text); //DEBUG
                    errorMessage('#verification-form', 'Server returned error.');
                }).always(() => {
    
                });
            });
    
            el = document.getElementById('img-cropper');
    
            $uploadCrop = new Croppie(el, {
                viewport: { width: 180, height: 180, type: 'circle' },
                boundary: { width: 180, height: 180 },
                enableExif: true,
                showZoomer: true,
                enableOrientation: true
            });
    
            $('#btn-cropper-plus').off('click');
            $('#btn-cropper-plus').on('click', function() {
                var $btn = $('#btn-cropper-plus');
                if( $btn.html() == '+' ) {
                    $('#upload').trigger('click');
                } else {
                    var canvas = $('.cr-image').get(0),
                        ctx = canvas.getContext('2d');
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    $('.col-cropper').removeClass('ready');
                    $("#cropped-img").attr("src", siteUrl + "/assets/images/sig/ico-monogram.png");
                    $("#drag-msg").attr('style', 'visibility:hidden');
                    $('#upload').val('');
                    $uploadCrop.setZoom(0);
                    $btn.html('+');
                }
            });
    
            $('#upload').off('change');
            $('#upload').on('change', function() {
                if( ! window.FileReader ) {
                    alert("Sorry - your browser doesn't support the file reading functionality");
                    return;
                }
                if (this.files && this.files[0]) {
                    var reader = new FileReader();
                    reader.onload = function(e) {
                        $('#btn-cropper-plus').html('x');
                        $('.col-cropper').addClass('ready');
                        $("#drag-msg").attr('style', 'font-size:90%');
                        $uploadCrop.bind({
                            url: e.target.result
                        });
                    }
                    reader.readAsDataURL(this.files[0]);                    
                }
            });
    
            $('.upload-result').off('click');
            $('.upload-result').on('click', function(e) {
                e.preventDefault();
    
                $('.upload-result').text('Saving').prop("disabled", false);
    
                $uploadCrop.result({
                    type: 'base64',
                    size: 'viewport'
                }).then(function(base64) {
                    const data = getFormData('#verification-form');
                    data.portrait = base64.replace('data:image/png;base64,', '');
                    $.ajax({
                        url: `${apiUrl}/upload`,
                        crossDomain: true,
                        type: "POST",
                        contentType: "application/json",
                        dataType: 'json',
                        data: JSON.stringify(data),
                    }).done(response => {
                        if(response.result == 'SUCCESS') {
                            //TODO set cookie maybe
                            $("#cropped-img").attr("src", portraitUrl + "/" + response.portrait + ".png");
                        } else {
                            console.log('upload API returned error');
                            // $("#cropped-img").attr("src", "/assets/images/sig/signature-placeholder.png");
                            $("#cropped-img").attr("src", "/assets/images/sig/ico-monogram.png");
                            errorMessage('.img-cropper-wrap', 'Server returned error.');
                        }
                    }).fail((xhr, resp, text) => {
                        console.log(xhr, resp, text); //DEBUG
                        errorMessage('.img-cropper-wrap', 'Server returned error.');
                    }).always(() => {
                        $('.upload-result').text('Save').prop("disabled", false);
                    });
                });
            });
    
            $('#generator-form-main input, #generator-form-social input').off('input');
            $('#generator-form-main input, #generator-form-social input').on('input', function(e) {
                const key = e.target.value.slice(-1);
                const input = "#" + $(this).attr('id') + '-sig';

                if(e.target.value === '' && !$(this).hasClass('input-apt')) {
                    const defaultValue = $(this).data('default') || e.target.placeholder;
                    if ($(input).is("a")) {
                        $(input).attr("href", defaultValue);
                    } else {
                        $(input).html(defaultValue);
                    }
                    toggleOptionalPhone();
                    return;
                }
                if ($(this).hasClass('input-addr') || $(this).hasClass('input-apt')) {
                    if( allowedCharacters_addr.test(key) ) {
                        let addr = $('#address').val(),
                            apt = $('#apt').val();
                        if( apt ) {
                            addr += "\n<br>\n" + apt;
                        }
                        console.log('address', addr);
                        $('#address-sig').html(addr);
                    } else {
                        e.target.value = e.target.value.slice(0, -1);
                    }
                } else if ( ! allowedCharacters.test(key) ) {
                    if( $(this).hasClass('input-url') && allowedCharacters_url.test(key) ) {
                        if ($(input).is("a")) {
                            $(input).attr("href", $(this).val());
                        } else {
                            $(input).html($(this).val());
                        }
                    } else if( $(this).hasClass('input-addr') && allowedCharacters_addr.test(key) ) {
                        $(input).html($(this).val());
                    } else if( $(this).hasClass('input-title') && allowedCharacters_title.test(key) ) {
                        $(input).html($(this).val());
                    } else {
                        e.target.value = e.target.value.slice(0, -1);
                    }
                } else if ($(this).hasClass('input-phone')) {
                    if( allowedCharacters_phone.test(key) ) {
                        if( key == '-' || e.target.value.length == 3 || e.target.value.length == 7 ) {
                            e.target.value += '.';
                        }
                        $(input).html($(this).val());
                    } else {
                        e.target.value = e.target.value.slice(0, -1);
                    }
                    toggleOptionalPhone();
                } else if ($(this).hasClass('input-zip')) {
                    if( allowedCharacters_zip.test(key) ) {
                        $(input).html($(this).val());
                    } else {
                        e.target.value = e.target.value.slice(0, -1);
                    }
                } else {
                    if ($(input).is("a")) {
                        $(input).attr("href", $(this).val());
                    } else {
                        if ($(this).attr('id') === "fname" || $(this).attr('id') === "lname") {
                            $("#dynamic-fname").html($('#fname').val() + "'s" );
                            $("#cropped-img").attr("alt", $('#fname').val() + " " + $('#lname').val());
                        }
                        $(input).html($(this).val());
                    }
                }
            });
            $('#generator-form-main input, #generator-form-social input').off('paste');
            $('#generator-form-main input, #generator-form-social input').on('paste', function(e) {
                e.preventDefault();
                const pasted = e.originalEvent.clipboardData || window.clipboardData;
                e.target.value = pasted.getData("text").replace(/[^\p{Alpha}\p{M}\p{Zs}0-9\s':\/\-.@,#&()]/gu, '');
                $(e.target).trigger('input');
            });
            $('#generator-form-main input.input-phone').off('keydown');
            $('#generator-form-main input.input-phone').on('keydown', function(e) {
                if( e.key == "Backspace" && e.target.value.length > 1 ) {
                    e.target.value = e.target.value.slice(0, -1);
                    e.preventDefault();
                    $("#" + $(this).attr('id') + '-sig').html($(this).val());
                    toggleOptionalPhone();
                }
            });
    
            // copy CODE of signature
            $('#copy-signature').off('click');
            $('#copy-signature').on('click', function() {
    
                updateTokens();
                
                const codeblock = $('#signature-code-custom');
                const toast = $('<div class="toast">Copied</div>');
                codeblock.select();
    
                document.execCommand('copy');
    
                $('.copy-email').append(toast);
    
                setTimeout(function() {
                    toast.css({
                    'opacity': '1',
                    'transform': 'translateY(2px)'
                    });
                }, 100);
    
                setTimeout(function() {
                    toast.css({
                    'opacity': '0',
                    'transform': 'translateY(-48px)'
                    });
                }, 2000);
    
                setTimeout(function() {
                    toast.remove();
                }, 2300);
            });
    
    
            //copy element instead of html code

            $("#copy-element").off('click');
            $("#copy-element").on("click", function() {
                var targetId = 'signature-block';
                var targetElement = document.getElementById(targetId);
                const toast = $('<div class="toast">Copied</div>');            
                var range = document.createRange();
    
                $('.copy-email').append(toast);
    

                range.selectNode(targetElement);
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
                
                targetElement.addEventListener("copy", evt => {
                    evt.clipboardData.setData("text/html", targetElement.outerHTML);
                    evt.preventDefault();
                }, { once: true });
                document.execCommand('copy');
                
                window.getSelection().removeAllRanges();
    
                setTimeout(function() {
                    toast.css({
                    'opacity': '1',
                    'transform': 'translateY(2px)'
                    });
                }, 100);
    
                setTimeout(function() {
                    toast.css({
                    'opacity': '0',
                    'transform': 'translateY(-48px)'
                    });
                }, 2000);
    
                setTimeout(function() {
                    toast.remove();
                }, 2300);
            });
    
        $('.modal-background').off('click');
        $('.modal-background').on('click', function(e) {
            if ($(e.target).hasClass('modal-background')) {
              closeModal();
            }
          });
      
          $('.launch-modal').off('click');
          $('.launch-modal').on('click', function() {
            let modalId = $(this).data('modal-id');
            $('.modal-background').addClass('open');                
            setTimeout(function() {
              openModal(modalId);
            }, 400);
          });
      
          $('.close-button').off('click');
          $('.close-button').on('click', function() {
            closeModal();
          });

          $('.print-button').off('click');
          $('.print-button').on('click', function() {
            window.print();
          });
      
          function closeModal() {
            $('.modal-background').removeClass('open');
            $('.modal-window').removeClass('open');
          }
      
          function openModal(modalId) {
            $('#' + modalId).addClass('open');
            $('.modal-background').addClass('open');
      
            setTimeout(function() {
              $('.modal-window.open').addClass('slide-in');
            }, 400);
          }
      
      
      
          /* verification code */
          function updateCodeValue() {
            var codeValue = '';
            
            if ($(window).width() <= 767) {
              var singleInputValue = $('#single-input').val();
              codeValue = singleInputValue.substr(0, 6);
            } else {
              $('.desktop-input').each(function() {
                codeValue += $(this).val();
              });
              codeValue = codeValue.substr(0, 6);
            }
            
            $('#code').val(codeValue);
          }
        
          $('.digit-input').off('input');
          $('.digit-input').on('input', function(e) {
            var inputValue = $(this).val();
            var sanitizedValue = inputValue.replace(/\D/g, '');
            $(this).val(sanitizedValue);
        
            if (sanitizedValue.length === 1) {
              var currentBoxIndex = $('.digit-input').index(this);
              var nextBoxIndex = currentBoxIndex + 1;
        
              if (nextBoxIndex < $('.digit-input').length) {
                var nextBox = $('.digit-input').eq(nextBoxIndex);
                nextBox.focus();
              } else {
                updateCodeValue();
              }
            }
          });
    
          $('.digit-input').off('focus');
          $('.digit-input').on('focus', function(e) {
            $(this).trigger('select');
          });
        
          $('.digit-input').off('keydown');
          $('.digit-input').on('keydown', function(e) {
            var key = e.which || e.keyCode;
        
            if (key === 8 && $(this).val().length === 0) {
              var previousBoxIndex = $('.digit-input').index(this) - 1;
              var previousBox = $('.digit-input').eq(previousBoxIndex);
        
              if (previousBoxIndex >= 0) {
                previousBox.focus();
                previousBox.val('');
                updateCodeValue();
              }
            }
          });
        
          $('.single-input').off('input');
          $('.single-input').on('input', function(e) {
            var inputValue = $(this).val();
            var sanitizedValue = inputValue.replace(/\D/g, '');
            var truncatedValue = sanitizedValue.slice(0, 6);
            $(this).val(truncatedValue);
            updateCodeValue();
          });
        
          $('.desktop-input').off('keyup');
          $(".desktop-input").on('keyup', function(e) {
            updateCodeValue();
          });
        
          // Prevent non-digit input
          $('.digit-input, .single-input').off('keypress');
          $('.digit-input, .single-input').on('keypress', function(e) {
            return /\d/.test(String.fromCharCode(e.which));
          });
        
          $('.digit-input, .single-input').off('paste');
          $('.digit-input, .single-input').on('paste', function(e) {
              e.preventDefault();
              var clipboardData = e.originalEvent.clipboardData || window.clipboardData;
              var pastedData = clipboardData.getData('text');
              var sanitizedValue = pastedData.replace(/\D/g, '');
              var inputBoxes = $(this).closest('.verification-codes').find('.digit-input');
            
              $('.digit-input').trigger('blur');
              inputBoxes.each(function(index) {
                if (index < sanitizedValue.length) {
                  $(this).val(sanitizedValue.charAt(index));
                } else {
                  if(index == sanitizedValue.length) {
                    $(this).trigger('focus');
                  }
                  return false;
                }
              });
            
              updateCodeValue();
          });
      
          $(window).off('resize load');
    
          $(window).on('resize load', function() {
            updateCodeValue();
          });
    
          set_img_paths();
        }
        $('input[type="url"]').on('blur', function(e) {
            const $el = $(e.target),
                $target = $('#' + $el.attr('id') + '-sig');         
            if( $el.val() && ! /^https?:\/\//.test( $el.val() ) ) {
                $el.val( 'https://' + $el.val() );
                if( $target.is('a') ) {
                    $target.attr( 'href', $el.val() );
                } else {
                    $target.html( $el.val() );
                }
            }
        });
        $('.steps input').on('blur', function(e) {
            if( $('#form-step-1').get(0).checkValidity() ) {
                $('#btn-next-1').attr('disabled', false);
            }
            if( $('#form-step-2').get(0).checkValidity() ) {
                $('#btn-next-2').attr('disabled', false);
            }
        });
        $('#btn-next-1').on('click', function(e) {
            e.preventDefault();
            $('#form-step-1').addClass('checked');
            if( ! $('#form-step-1').get(0).reportValidity() ) {
                $('#btn-next-1').attr('disabled', true);
                return;
            }
            $('.steps').addClass('hidden');
            $('.step-2').removeClass('hidden');
        });
        $('#btn-prev-2').on('click', function(e) {
            e.preventDefault();
            $('.steps').addClass('hidden');
            $('.step-1').removeClass('hidden');
        });
        $('#btn-next-2').on('click', function(e) {
            e.preventDefault();
            $('#form-step-2').addClass('checked');
            if( ! $('#form-step-2').get(0).reportValidity() ) {
                $('#btn-next-2').attr('disabled', true);
                return;
            }
            $('.steps').addClass('hidden');
            $('.step-3').removeClass('hidden');
        });
        $('#btn-prev-3').on('click', function(e) {
            e.preventDefault();
            $('.steps').addClass('hidden');
            $('.step-2').removeClass('hidden');
        });
    }
};
$(signatureInit);
$(document).on('lfbb:load', signatureInit);

function validateCode(form) {
    var $form = $(form);
    var isDesktop = $(window).width() > 767;
  
    if (isDesktop) {
      // desktop validation
      var isValid = true;
      $form.find('.desktop-input').each(function() {
        if ($(this).val().trim() === '') {
          isValid = false;
          return false;
        }
      });
  
      if (!isValid) {
        $form.addClass('failed');
        return false;
      } else {
        $form.removeClass('failed').addClass('success');
        return true;
      }
    } else {
      // mobile validation
      var singleInputValue = $form.find('#single-input').val().trim();
  
      if (singleInputValue === '' || singleInputValue.length !== 6) {
        $form.addClass('failed');
        return false;
      } else {
        $form.removeClass('failed').addClass('success');
        return true;
      }
    }
}

//add domain to img paths
function set_img_paths() {
  $('#signature-block img').each(function() {
    var $img = $(this);
    var src = $img.attr('src');
    var updatedSrc = siteUrl + src;
    $img.attr('src', updatedSrc);
  });
}

// toggle optional phone row
var phoneRow = $('<tr><td width="12" height="12" align="left" valign="middle" style="line-height:12px;padding:6px"><img src="' + siteUrl + '/assets/images/sig/ip36.png" width="12" height="12" alt="Mobile" style="width:12px;height:12px;max-width:12px;max-height:12px;line-height:12px"></td><td height="12" align="left" style="font-family:Arial,Helvetica,sans-serif;color:#041e42;font-size:12px;line-height:12px;padding:6px" valign="top"><span id="phone-sig">111.222.3333</span></td></tr>');
function toggleOptionalPhone() {
    var $phone = $('#phone');
    if( $phone.val() ) {
        if( phoneRow ) {
            $('#ophone-sig').closest('tr').after(phoneRow);
            $("#phone-sig").html($phone.val());
            phoneRow = null;
        }
    } else {
        if( !phoneRow ) {
            phoneRow = $('#phone-sig').closest('tr').detach();
        }
    }
}

function updateTokens() {
  var textareaValue = $("#signature-code").val();
  var monogramURL = "";
  var fullname = $("#fname").val() + " " + $("#lname").val();

  //replace with uploaded version if available
  monogramURL =   $("#cropped-img").attr("src");

  var tokenValues = {
    '%IMGPATH%': siteUrl,
    '%FULLNAME%': (fullname !== ' ') ? fullname : 'Johnathan Smith',
    '%FIRSTNAME%': ($("#fname").val() !== '') ? $("#fname").val() : 'Johnathan',
    '%LASTNAME%': ($("#lname").val() !== '') ? $("#lname").val() : 'Smith',
    '%MONOGRAMURL%': monogramURL,
    '%JOBTITLE%': ($("#job").val() !== '') ? $("#job").val() : 'Real Estate Agent',
    '%OFFICE%': ($("#office").val() !== '') ? $("#office").val() : 'Long & Foster',
    '%LICNUM%': ($("#licnum").val() !== '') ? $("#licnum").val() : '',
    '%PHONE%': ($("#phone").val() !== '') ? $("#phone").val() : '',
    '%OPHONE%': ($("#ophone").val() !== '') ? $("#ophone").val() : '111.222.3333',
    '%EMAIL%': ($("#email").val() !== '') ? $("#email").val() : 'john.smith@longandfoster.com',
    '%WEBSITE%': ($("#website").val() !== '') ? $("#website").val() : 'https://longandfoster.com',
    '%ADDRESS%': ($("#address").val() !== '') ? $("#address").val() : '3975 Fair Ridge Drive',
    '%APT%': ($("#apt").val() !== '') ? $("#apt").val() : '',
    '%CITY%': ($("#city").val() !== '') ? $("#city").val() : 'Fairfax',
    '%STATE%': ($("#state").val() !== '') ? $("#state").val() : 'VA',
    '%ZIP%': ($("#zip").val() !== '') ? $("#zip").val() : '22033',
    '%FB%': ($("#fb").val() !== '') ? $("#fb").val() : 'https://www.facebook.com/LongandFoster',
    '%LI%': ($("#li").val() !== '') ? $("#li").val() : 'https://www.linkedin.com/company/longandfosterco',
    '%TW%': ($("#tw").val() !== '') ? $("#tw").val() : 'https://twitter.com/longandfoster',
    '%IG%': ($("#ig").val() !== '') ? $("#ig").val() : 'https://www.instagram.com/longandfoster/',
    '%YT%': ($("#yt").val() !== '') ? $("#yt").val() : 'https://www.youtube.com/user/longandfosterre',
  };

  for (var token in tokenValues) {
    if(tokenValues[token] == '') {
        console.log('remove conditional for', token);
        var conditionalRegex = new RegExp('{#if ' + token + '}[^{]*{#\/if}', 'gs');
        console.log(textareaValue.match(conditionalRegex));
        textareaValue = textareaValue.replace(conditionalRegex, '');
        console.log(textareaValue.match(conditionalRegex));
    }
    var placeholder = token.replace(/'/g, '&#39;').replace(/"/g, '&#34;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    var tokenRegex = new RegExp(placeholder.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), 'g');
    textareaValue = textareaValue.replace(tokenRegex, tokenValues[token]);
  }
  var cleanupRegex = new RegExp('{#/?if[^}]*}', 'gs');
  textareaValue = textareaValue.replace(cleanupRegex, '');
  $("#signature-code-custom").val(textareaValue);
}

// Year copyright
var date = new Date().getFullYear();
document.getElementById("year").innerHTML = date;
